import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { GetUser, RequiredProfile } from "../../utils/consts";

import Loading from "../../components/loading/Loading";
import ProfilePreviewCard from "../../components/ProfilePreviewCard/ProfilePreviewCard";

import Panel from "@atlaskit/panel";
export default class User extends Component {
  state = { loading: true };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const location = this.props.location || {};
      const search = location.search || "";
      const params = new URLSearchParams(search);
      const uid = params.get("uid");
      const user = await GetUser(uid);
      this.setState({
        user: user || {},
        uid: uid || "",
        loading: false
      });
    } catch (error) {
      this.setState({ user: {}, uid: "", loading: false });
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Retry"
      });
    }
  };

  goTo = url => window.location.assign(url);

  render() {
    const user = this.state.user || {};
    return (
      <div className="user">
        <Helmet>
          <title>{`User | ${user.displayName}`}</title>
        </Helmet>
        {this.state.loading && <Loading />}
        {!this.state.loading &&
          !!Object.keys(user).length && (
            <div className="application__applicant">
              <div className="application__profile-card-container">
                <ProfilePreviewCard
                  data={user}
                  actions={[
                    {
                      label: "Employment",
                      id: "employment-letter",
                      callback: () => this.goTo(`${user.employmentLetter}`)
                    },
                    {
                      label: "Credit",
                      id: "credit-report",
                      callback: () => this.goTo(`${user.creditReport}`)
                    }
                  ]}
                />
              </div>
              <div className="application__user-attrs">
                {Object.keys(user)
                  .filter(item => Object.keys(RequiredProfile)[item] !== -1)
                  .map(item => user[item])
                  .map((item, i) => (
                    <Panel
                      className="application__attr"
                      key={i}
                      header={<span>{Object.keys(user)[i]}</span>}
                    >
                      <div className="application__attr-content">
                        {JSON.stringify(item)}
                      </div>
                    </Panel>
                  ))}
              </div>
            </div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/User.js